import { requiredField } from '../../helperFuncs';
import * as Yup from 'yup';

export const createNoteValidationSchema = 
  Yup.object({
    date_note: 
      Yup.date()
        .required(requiredField),
    note: 
      Yup.string()
        .required(requiredField),
  });
  
export const createCommValidationSchema = 
  Yup.object({
    subject: 
      Yup.string()
        .required(requiredField),
    record: 
      Yup.string()
        .required(requiredField),
    date: 
      Yup.date()
        .required(requiredField),
    time: 
      Yup.string()
        .required(requiredField),
    category: 
      Yup.string()
        .nullable()
        .required('Συμπληρώστε το πεδίο'),
  });

export const batchEmailsValidationSchema = 
  Yup.object({
    recipients: 
      Yup.string()
        .required(requiredField),
    subject: 
      Yup.string()
        .required(requiredField),
    description: 
      Yup.string()
        .required(requiredField),
    category_id: 
      Yup.number()
        .required(requiredField),
  });
